import { Component, OnDestroy, OnInit } from '@angular/core';
// import { AuthUserModel } from 'src/app/shared/models/auth-user.model';
// import { ServiceModel } from 'src/app/shared/models/service.model';
import { AuthService } from 'src/app/shared/services/auth.service';
// import { DashboardService } from '../services/dashboard.service';
// import { environment } from 'src/environments/environment';
// import { ApiService } from 'src/app/shared/services/api.service';
import { UserModel } from 'src/app/shared/models/user.model';
// import { LayoutService } from 'src/app/shared/services/layout.service';
// import { BreadcrumbsService } from 'src/app/layout/breadcrumbs/service/breadcrumbs.service';
// import { Router } from '@angular/router';
import { UserServicesService } from 'src/app/layout/services/user-services.service';
import { DashboardService } from '../services/dashboard.service';
import { LastConfigurations, ServicenumbersModel, ShortcutList } from './models/dashboard.model';
import { ClientContentDistributionService } from 'src/app/content-distribution/public/services/contentdistribution.service';
import { VenuesService } from 'src/app/venues/private/services/venues.service';
import { Subscription } from 'rxjs';
import { DemoServiceModel } from 'src/app/shared/models/service.model';
import { SuccessResponse } from 'src/app/shared/interfaces/response.interface';
import { HIDE_LOADER } from 'src/app/shared/interceptors/loader.interceptor';
import { HttpContext } from '@angular/common/http';

@Component({
  selector: 'app-dashboard-home',
  templateUrl: './dashboard-home.component.html',
  styleUrls: ['./dashboard-home.component.scss'],
})
export class DashboardHomeComponent implements OnInit, OnDestroy {
  public user: any;
  public shortcutsList: Array<ShortcutList>;
  public shortcutsListByService: {
    [key: string]: Array<ShortcutList>;
  };
  public lastConfigurations: Array<LastConfigurations> = [];

  public numbers: {
    venues: ServicenumbersModel;
    configurations: ServicenumbersModel;
    domains: ServicenumbersModel;
  } = {
    venues: {
      service: 'contentdistribution',
      numbers: {
        value: 0,
        text: 'My venues',
        key: 'venues',
        icon: this.userServicesService.servicesIconsPath + 'icon-venues-black.svg',
      },
    },
    configurations: {
      service: 'contentdistribution',
      numbers: {
        value: 0,
        text: 'Configurations',
        key: 'configurations',
        icon: this.userServicesService.servicesIconsPath + 'icon-venues-black.svg',
      },
    },
    domains: {
      service: 'contentdistribution',
      numbers: {
        value: 0,
        text: 'My domains',
        key: 'domains',
        icon: this.userServicesService.servicesIconsPath + 'icon-venues-black.svg',
      },
    },
  };
  public loadingnumbers: boolean = true;
  public subs$: Array<Subscription> = [];
  // public servicesList: Array<ServiceModel>;
  // public internalServices: Array<ServiceModel>;
  // public publicServices: Array<ServiceModel>;

  constructor(
    private authService: AuthService,
    private dashboardService: DashboardService,
    private clientCDService: ClientContentDistributionService,
    private venuesService: VenuesService,
    private userServicesService: UserServicesService // private dashboardService: DashboardService,
  ) {
    // private apiService: ApiService,
    // private layoutService: LayoutService,
    // private breadcrumbsService: BreadcrumbsService,
    // private router: Router
    // this.internalServices = [];
    // this.publicServices = [];
    this.shortcutsList = [];
    this.shortcutsListByService = {
      editor2dmaps: [
        {
          title: '2D Maps Editor',
          path: null,
          iconUrl: '/assets/img/icons/arrow-full-right-white.svg',
          position: 1,
        },
      ],
      contentdistribution: [
        {
          title: 'My Venues',
          path: '/content-distribution/public/my-venues',
          iconUrl: '/assets/img/icons/arrow-full-right-white.svg',
          position: 2,
          type: 'configurations',
        },
      ],
      catalog: [
        {
          title: 'Catalog',
          path: '/catalog/public/list',
          //iconUrl: this.userServicesService.servicesIconsPath + 'icon-catalog.svg',
          iconUrl: '/assets/img/icons/arrow-full-right-white.svg',
          position: 3,
        },
        // {
        //   title: '3D Views Catalog',
        //   path: '/catalog/public/3dviews',
        //   iconUrl: '/assets/img/icons/arrow-full-right-white.svg',
        //   position: 4,
        // },
      ],
    };
  }

  ngOnInit(): void {
    this.authService.getUserLogged().subscribe((user: UserModel) => {
      if (user) {
        this.user = user;
        let services = user.client.services as DemoServiceModel[];
        // // console.log(services);
        services.find(x => {
          if (this.shortcutsListByService[x.name]) {
            if (x.name === 'editor2dmaps') {
              if (x.demo) {
                this.shortcutsListByService[x.name][0].path = '/editor2dmaps/public/demo';
              } else {
                this.shortcutsListByService[x.name][0].path = '/editor2dmaps/public/list';
              }
            }
            this.shortcutsList = this.shortcutsList.concat(this.shortcutsListByService[x.name]);
          }
          if (x.name === 'contentdistribution') {
            this.loadContentDistSummary();
          }
        });
        //sort by position
        this.shortcutsList.sort((a, b) => a.position - b.position);
      }
    });

    // console.log(this.shortcutsList);
  }
  ngOnDestroy(): void {
    this.subs$.forEach(o => o.unsubscribe());
  }
  public loadContentDistSummary() {
    this.dashboardService.getCDClient().subscribe(res => {
      this.clientCDService.setAsyncCDClient(res.result);
      let keys = res.result.data.venues.map(x => x.key);
      //Remove duplicates
      keys = keys.filter((value, index) => keys.indexOf(value) === index);

      const fields = 'name,city';
      const related = 'venuetype';
      const hideLoader = true;

      this.lastConfigurations = res.result.data.venues;
      const context = new HttpContext().set(HIDE_LOADER, true);
      const v$ = this.venuesService
        .getByKeyList({ keys: keys }, fields, related, context)
        .subscribe((venuesRes: SuccessResponse) => {
          venuesRes.data.map(res => {
            this.lastConfigurations.map(i => {
              if (i.key === res.key) {
                i.venue = res;
              }
            });
          });
        });
      this.subs$.push(v$);
      this.numbers.venues = {
        service: 'contentdistribution',
        numbers: {
          value: res.result.data.numbers.uniquevenues,
          text: 'My venues',
          key: 'venues',
          icon: this.userServicesService.servicesIconsPath + 'icon-venues-black.svg',
        },
      };

      this.numbers.configurations = {
        service: 'contentdistribution',
        numbers: {
          value: res.result.data.numbers.venues,
          text: 'Configurations',
          key: 'configurations',
          icon: this.userServicesService.servicesIconsPath + 'icon-venues-black.svg',
        },
      };

      this.numbers.domains = {
        service: 'contentdistribution',
        numbers: {
          items: res.result.data.domains,
          value: res.result.data.numbers.domains,
          text: 'My domains',
          key: 'domains',
          icon: this.userServicesService.servicesIconsPath + 'icon-venues-black.svg',
        },
      };
      this.loadingnumbers = false;
      // console.log('false');
    });
  }
}
